import { useNavigate, useRouteLoaderData } from '@remix-run/react';
import type { TNavbarItemElement } from '@shared/dream-components';
import { NavbarMenuItemV2 as NavbarMenuItemElement } from '@shared/dream-components';
import type { ReactNode } from 'react';

import { getClientSideNavigationHandler, updateNodeAttributes } from '../utils/getNodeActionAndVisibility';

import { usePageContext } from '~/context/usePageContext';
import type { RootLoaderData } from '~/root';

interface Props {
  node: TNavbarItemElement;
  children: ReactNode | ReactNode[];
  screen: 'desktop' | 'mobile';
}

const ClientNavbarMenuItem = ({ node, children, screen }: Props) => {
  const navigate = useNavigate();
  const { subscription } = usePageContext();
  const isPremiumUser = subscription?.tier === 'premium';
  const { isLoggedIn } = useRouteLoaderData<RootLoaderData>('root') || {};

  const updatedNode = updateNodeAttributes(node, Boolean(isLoggedIn), isPremiumUser, subscription);
  const handleClientSideNavigation = getClientSideNavigationHandler(updatedNode, subscription, navigate);

  return (
    <NavbarMenuItemElement
      element={updatedNode}
      controlbyselected="false"
      screen={screen}
      onClick={handleClientSideNavigation}
    >
      {children}
    </NavbarMenuItemElement>
  );
};

const NavbarMenuItem = ({ node, children, screen }: Props) => {
  return (
    <ClientNavbarMenuItem node={node} screen={screen}>
      {children}
    </ClientNavbarMenuItem>
  );
};

export default NavbarMenuItem;
